import React, { useEffect } from 'react';
import defaultLocales from 'globals/locales/default';
import { observer } from 'mobx-react';
import { useAppContext } from 'contexts/AppContext';
import { isLastElement } from 'globals/utils';
import {
  Row,
  RowSpecial,
  Caption,
  Currency,
  CaptionSpecial,
  CurrencySpecial,
  Legend,
} from './BillingSummary.style-elements';

const BillingSummary: React.FC = () => {
  const {
    upgradeCalculation: { getCalculations, init: initCalculations },
  } = useAppContext();
  const calculations = getCalculations();

  useEffect(() => {
    initCalculations();
  }, [initCalculations]);

  return (
    <>
      {calculations.map(
        ({ id, amount: { value, format, currency }, caption }, idx) =>
          !isLastElement(idx, calculations.length) ? (
            <Row key={id}>
              <Caption>{caption}</Caption>
              <Currency format={format} currency={currency}>
                {value}
              </Currency>
            </Row>
          ) : (
            <RowSpecial key={id}>
              <CaptionSpecial>{caption}</CaptionSpecial>
              <CurrencySpecial format={format} currency={currency}>
                {value}
              </CurrencySpecial>
            </RowSpecial>
          )
      )}
      <Legend>{defaultLocales.billingLegend}</Legend>
    </>
  );
};

export default observer(BillingSummary);
